import {auth, review, searchLawyer} from '@/api-services'
import {errorHandler, successHandler} from '@/utils/handler'
import {toast} from '@/utils/toast'
import {defineStore} from 'pinia'
import {parseLinkHeader, paginationHandler} from '@/utils/common'

export const useLawyerStore = defineStore('lawyerStore', {
  state: () => ({
    allLawyers: [],
    allSearchedLawyers: [],
    unVerifiedLawyers: [],
    unConfirmedLawyers: [],
    rejectedLawyers: [],
    verifiedLawyers: [],
    reviewedLawyers: [],
    allReviewableLawyers: [],
    lawyerDetail: {},
    isCreateSuccess: false,
    isUpdateSuccess: true,
    isReviewPosted: false,
    isSearchSuccess: false,
    isAmendmentSuccess: false,
    loading: false,
    actionLoading: false,
    addReviewLoading: false,
    error: null,
    links: {},
    verifiedLawyersLink: {},
    unVerifiedLawyersLink: {},
    unConfirmedLawyersLink: {},
    rejectedLawyersLink: {},
    verifiedLawyersLoading: false,
    unVerifiedLawyersLoading: false,
    unConfirmedLawyersLoading: false,
    rejectedLawyersLoading: false,
    currentPage: {
      verifiedLawyers: 1,
      unConfirmedLawyers: 1,
      unVerifiedLawyers: 1,
      rejectedLawyers: 1,
    },
    perPage: 20,
  }),
  getters: {
    getAllLawyersWithSerialNumber(state) {
        return state.verifiedLawyers.map((val, index)=>({
            ...val,
            serialNumber: (state.currentPage.verifiedLawyers - 1) * state.perPage + index + 1,
        }))
    },

    getUnVerifiedLawyersWithSerialNumber(state) {
        return state.unVerifiedLawyers.map((val, index)=>({
            ...val,
            serialNumber: (state.currentPage.unVerifiedLawyers - 1) * state.perPage + index + 1,
        }))
    },

    getUnConfirmedLawyersWithSerialNumber(state) {
        return state.unConfirmedLawyers.map((val, index)=>({
            ...val,
            serialNumber: (state.currentPage.unConfirmedLawyers - 1) * state.perPage + index + 1,
        }))
    },
    getRejectedLawyersWithSerialNumber(state) {
      return state.rejectedLawyers.map((val, index)=>({
          ...val,
          serialNumber: (state.currentPage.rejectedLawyers - 1) * state.perPage + index + 1,
      }))
  },
  },
  actions: {
    async getAllLawyers() {
        this.loading = true
        try {
        const response = await auth.getAllLawyer()
        const data = await response.data
        this.links = parseLinkHeader(response.headers.link)
        this.verifiedLawyersLink = parseLinkHeader(response.headers.link)
        this.verifiedLawyers = data
        this.allLawyers = data
      } catch (error) {
        error.map((e) => {
          const errorMsg = errorHandler(e)
          this.error = errorMsg
          toast.error(errorMsg)
        })
      } finally {
        this.loading = false
      }
    },

    async getReviewableLawyers() {
      this.loading = true
      try {
      const response = await auth.getReviewableLawyers()
      const data = await response.data
      this.links = parseLinkHeader(response.headers.link)
      this.allReviewableLawyers = data
    } catch (error) {
      error.map((e) => {
        const errorMsg = errorHandler(e)
        this.error = errorMsg
        toast.error(errorMsg)
      })
    } finally {
      this.loading = false
    }
  },

    async getLawyersWithReview() {
      this.loading = true
      try {
      const response = await auth.getReviewedLawyer()
      const data = await response.data
      this.links = parseLinkHeader(response.headers.link)
      this.reviewedLawyers = data
    } catch (error) {
      error.map((e) => {
        const errorMsg = errorHandler(e)
        this.error = errorMsg
        toast.error(errorMsg)
      })
    } finally {
      this.loading = false
    }
  },

    async getAllSearchedLawyers(payload) {
      this.loading = true
      try {
      const response = await searchLawyer.getSearchList(payload)
      const data = await response.data
      this.isSearchSuccess = true
      this.allSearchedLawyers = data
    } catch (error) {
      error.map((e) => {
        const errorMsg = errorHandler(e)
        this.error = errorMsg
        toast.error(errorMsg)
      })
    } finally {
      this.loading = false
    }
  },

  async getAllLawyersByPracticeArea(specialization) {
    this.loading = true
    try {
    const response = await searchLawyer.getBySpecialization(specialization)
    const data = await response.data
    this.isSearchSuccess = true
    this.allSearchedLawyers = data
  } catch (error) {
    error.map((e) => {
      const errorMsg = errorHandler(e)
      this.error = errorMsg
      toast.error(errorMsg)
    })
  } finally {
    this.loading = false
  }
},

async getAllLawyersByDistrict(district) {
  this.loading = true
  try {
  const response = await searchLawyer.getByCity(district)
  const data = await response.data
  this.isSearchSuccess = true
  this.allSearchedLawyers = data
} catch (error) {
  error.map((e) => {
    const errorMsg = errorHandler(e)
    this.error = errorMsg
    toast.error(errorMsg)
  })
} finally {
  this.loading = false
}
},

    async createLawyer(lawyerData) {
      let formData = new FormData()
      formData.append('username', lawyerData.username)
      formData.append('first_name', lawyerData.first_name)
      if (lawyerData.middle_name) {
        formData.append('middle_name', lawyerData.middle_name)
      }
      formData.append('last_name', lawyerData.last_name)
      formData.append('email', lawyerData.email)
      formData.append('password', lawyerData.password)
      formData.append('password_confirmation', lawyerData.password_confirmation)
      formData.append('picture', lawyerData.picture, lawyerData.picture.name)
      formData.append('advocate_license', lawyerData.advocate_license, lawyerData.advocate_license.name)
      if (lawyerData.notary_image) {
        formData.append('notary_image', lawyerData.notary_image, lawyerData.notary_image.name)
      }
      if (lawyerData.translator_image) {
        formData.append('translator_image', lawyerData.translator_image, lawyerData.translator_image.name)
      }
      formData.append('specialization', lawyerData.specialization)
      formData.append('bar', lawyerData.bar)
      formData.append('city', lawyerData.city)
      formData.append('law_firm_name', lawyerData.law_firm_name)
      formData.append('law_firm_street_address', lawyerData.law_firm_street_address)
      formData.append('country', lawyerData.country)
      formData.append('phone_number', lawyerData.phone_number)
      formData.append('fax', lawyerData.fax)
      formData.append('comment', lawyerData.comment)
      this.loading = true
      try {
      const response = await auth.lawyerSignUp(formData)
      const data = await response.data
      this.lawyerDetail = data
      this.isCreateSuccess = true
      toast.success(successHandler('LAWYER_SIGNUP_SUCCESS'))
      toast.success(successHandler('THANK_INFO_MESSAGE'))
    } catch (error) {
      error.map((e) => {
        const errorMsg = errorHandler(e)
        this.error = errorMsg
        toast.error(errorMsg)
      })
    } finally {
      this.loading = false
    }
  },

  async updateLawyer(lawyerData) {
    let formData = new FormData()
    formData.append('username', lawyerData.username)
    formData.append('first_name', lawyerData.first_name)
    formData.append('last_name', lawyerData.last_name)
    formData.append('email', lawyerData.email)
    formData.append('password', lawyerData.password)
    formData.append('password_confirmation', lawyerData.password_confirmation)
    if (lawyerData.picture?.name) {
      formData.append('picture', lawyerData.picture, lawyerData.picture.name)
    }
    formData.append('bar', lawyerData.bar)
    formData.append('city', lawyerData.city)
    formData.append('law_firm_name', lawyerData.law_firm_name)
    formData.append('law_firm_street_address', lawyerData.law_firm_street_address)
    formData.append('country', lawyerData.country)
    formData.append('phone_number', lawyerData.phone_number)
    formData.append('fax', lawyerData.fax)
    formData.append('comment', lawyerData.comment)
    formData.append('is_verified', lawyerData.is_verified)
    formData.append('reject_message', lawyerData.reject_message)
    formData.append('specialization', lawyerData.specialization)
    this.actionLoading = true
    try {
    const response = await auth.updateLawyerProfile(formData)
    const data = await response.data
      this.lawyerDetail = data
      this.isUpdateSuccess = true
      toast.success(successHandler('LAWYER_UPDATE_SUCCESS'))
  } catch (error) {
    error.map((e) => {
      const errorMsg = errorHandler(e)
      this.error = errorMsg
      toast.error(errorMsg)
    })
  } finally {
    this.actionLoading = false
  }
},
async getUnverifiedLawyers() {
    this.loading = true
    try {
    const response = await auth.getUnverifiedLawyer()
    const data = await response.data
      this.unVerifiedLawyersLink = parseLinkHeader(response.headers.link)
      this.unVerifiedLawyers = data
  } catch (error) {
    error.map((e) => {
      const errorMsg = errorHandler(e)
      this.error = errorMsg
      toast.error(errorMsg)
    })
  } finally {
    this.loading = false
  }
},

async getUnConfirmedLawyers() {
    this.loading = true
    try {
    const response = await auth.getUnconfirmedLawyers()
    const data = await response.data
      this.unConfirmedLawyers = data
      this.unConfirmedLawyersLink = parseLinkHeader(response.headers.link)
  } catch (error) {
    error.map((e) => {
      const errorMsg = errorHandler(e)
      this.error = errorMsg
      toast.error(errorMsg)
    })
  } finally {
    this.loading = false
  }
},

async getRejectedLawyers() {
  this.loading = true
  try {
  const response = await auth.getRejectedLawyers()
  const data = await response.data
    this.rejectedLawyers = data
    this.rejectedLawyersLink = parseLinkHeader(response.headers.link)
} catch (error) {
  error.map((e) => {
    const errorMsg = errorHandler(e)
    this.error = errorMsg
    toast.error(errorMsg)
  })
} finally {
  this.loading = false
}
},

async getLawyerDetail(id) {
  this.loading = true
  try {
  const response = await auth.getLawyer(id)
  const data = await response.data
  this.lawyerDetail = data[0]
} catch (error) {
  error.map((e) => {
    const errorMsg = errorHandler(e)
    this.error = errorMsg
    toast.error(errorMsg)
  })
} finally {
  this.loading = false
}
},

async verifyLawyer(payload, id) {
  this.actionLoading = true
  try {
  await auth.verifyLawyer(payload, id)
  toast.success(successHandler('VERIFY_LAWYER_SUCCESS'))
} catch (error) {
  error.map((e) => {
  const errorMsg = errorHandler(e)
  this.error = errorMsg
  toast.error(errorMsg)
  })
} finally {
  this.actionLoading = false
}
},

async rejectLawyer(payload, id) {
  this.actionLoading = true
  try {
  await auth.rejectLawyer(payload, id)
  toast.success(successHandler('REJECT_LAWYER_SUCCESS'))
} catch (error) {
  error.map((e) => {
    const errorMsg = errorHandler(e)
    this.error = errorMsg
    toast.error(errorMsg)
  })
} finally {
  this.actionLoading = false
}
},

async amendLawyer(lawyerData, lawyerId) {
  let formData = new FormData()

  if (lawyerData.picture?.name) {
    formData.append('lawyer[picture]', lawyerData.picture, lawyerData.picture.name)
  }
  if (lawyerData.advocate_license?.name) {
    formData.append('lawyer[advocate_license]', lawyerData.advocate_license, lawyerData.advocate_license.name)
  }
  if (lawyerData.notary_image?.name) {
    formData.append('lawyer[notary_image]', lawyerData.notary_image, lawyerData.notary_image.name)
  }
  if (lawyerData.translator_image?.name) {
    formData.append('lawyer[translator_image]', lawyerData.translator_image, lawyerData.translator_image.name)
  }
  if (lawyerData.bar) {
    formData.append('lawyer[bar]', lawyerData.bar)
  }
  if (lawyerData.reject_message) {
    formData.append('lawyer[reject_message]', lawyerData.reject_message)
  }

  formData.append('lawyer[is_verified]', lawyerData.is_verified)

  this.actionLoading = true
  try {
  const response = await auth.amendmentLawyer(formData, lawyerId)
  const data = await response.data
    this.lawyerDetail = data
    this.isAmendmentSuccess = true
    toast.success(successHandler('LAWYER_UPDATE_SUCCESS'))
} catch (error) {
  error.map((e) => {
    const errorMsg = errorHandler(e)
    this.error = errorMsg
    toast.error(errorMsg)
  })
} finally {
  this.actionLoading = false
}
},

async resendConfirmation(payload) {
  this.actionLoading = true
  try {
  await auth.resendConfirmation(payload)
  toast.success(successHandler('RESEND_CONFIRMATION_SUCCESS'))
} catch (error) {
  error.map((e) => {
    const errorMsg = errorHandler(e)
    this.error = errorMsg
    toast.error(errorMsg)
  })
} finally {
  this.actionLoading = false
}
},

async addReview(id, payload) {
  this.addReviewLoading = true
  try {
  await review.postReview(id, payload)
  this.isReviewPosted = true
  toast.success(successHandler('CREATE_REVIEW_SUCCESS'))
} catch (error) {
  error.map((e) => {
    const errorMsg = errorHandler(e)
    this.error = errorMsg
    toast.error(errorMsg)
  })
} finally {
  this.addReviewLoading = false
}
},

async getNextPage(data, type='ALL') {
    const {value} = data
    try {
      const response = await paginationHandler(this.links.next)
      if (type==='REVIEWED_LAWYER') {
        this.reviewedLawyers = [...value, ...response.data]
      } else {
        this.allLawyers = [...value, ...response.data]
      }
      this.links = parseLinkHeader(response.headers.link)
    } catch (error) {
      error.map((e) => {
        const errorMsg = errorHandler(e)
        this.error = errorMsg
        toast.error(errorMsg)
      })
    }
  },

  async getTablePagination(page, type=null) {
    if (type) {
      this[`${type}Loading`] = true
    } else {
      this.loading = true
    }
    let response = []
    try {
      if (page === 'next') {
        this.currentPage[type] += 1
        response = await paginationHandler(this[`${type}Link`].next)
      } else if (page === 'prev') {
        this.currentPage[type] -= 1
        response = await paginationHandler(this[`${type}Link`].prev)
      }
      this[type] = response.data
      if (type) {
        this[`${type}Link`] = parseLinkHeader(response.headers.link)
      } else {
        this.link = parseLinkHeader(response.headers.link)
      }
    } catch (error) {
      const errorMsg = errorHandler(error)
      this.error = errorMsg
      toast.error(errorMsg)
    } finally {
      if (type) {
        this[`${type}Loading`] = false
      } else {
        this.loading = false
      }
    }
  },
  },
})
